import { LeaderboardResultSkeleton } from './LeaderboardResultSkeleton';

export const LeaderboardPageSkeleton = () => {
  return <LeaderboardResultSkeleton />;
};
